import { render, staticRenderFns } from "./SendIcon.vue?vue&type=template&id=4526f2aa&scoped=true&"
import script from "./SendIcon.vue?vue&type=script&lang=js&"
export * from "./SendIcon.vue?vue&type=script&lang=js&"
import style0 from "./SendIcon.vue?vue&type=style&index=0&id=4526f2aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4526f2aa",
  null
  
)

export default component.exports